import {
  SOCIAL_VIDEO_CONTAINER,
  SOCIAL_VIDEO,
  SOCIAL_VIDEO_POSTER,
  SOCIAL_VIDEO_BIG_ICON,
  SOCIAL_VIDEO_SMALL_ICON,
  SOCIAL_VIDEO_SOUND_OFF_ICON,
  SOCIAL_VIDEO_SOUND_ON_ICON
} from '../../classnames/video';
import { HIDDEN } from '../../classnames/design-system';
import { onActivationKey } from '../../shared/keyboard';
import { isMobile } from '../../utils/media';

export default class SocialVideo {
  constructor(container) {
    this.container = container;
    this.video = container.querySelector(`.${SOCIAL_VIDEO}`);
    this.poster = container.querySelector(`.${SOCIAL_VIDEO_POSTER}`);
    this.soundIconBig = container.querySelector(`.${SOCIAL_VIDEO_BIG_ICON}`);
    this.soundIconSmall = container.querySelector(`.${SOCIAL_VIDEO_SMALL_ICON}`);
    this.soundOffIcons = [...container.querySelectorAll(`.${SOCIAL_VIDEO_SOUND_OFF_ICON}`)];
    this.soundOnIcons = [...container.querySelectorAll(`.${SOCIAL_VIDEO_SOUND_ON_ICON}`)];
    this.animationTimeout = 900;
  }

  offSound = () => {
    this.video.muted = true;
  };

  onSound = () => {
    [...document.querySelectorAll(`.${SOCIAL_VIDEO_CONTAINER}`)].forEach((container) => {
      const video = container.querySelector(`.${SOCIAL_VIDEO}`);

      video.muted = true;
    });

    this.video.muted = false;
  };

  toggleSound = () => {
    if (this.video.muted) {
      this.onSound();
    } else {
      this.offSound();
    }
  };

  toggleSoundIcons = () => {
    if (this.video.muted) {
      this.soundOffIcons.forEach((icon) => icon.classList.remove(HIDDEN));
      this.soundOnIcons.forEach((icon) => icon.classList.add(HIDDEN));
      this.soundIconSmall?.setAttribute('aria-label', 'Unmute video');
    } else {
      this.soundOffIcons.forEach((icon) => icon.classList.add(HIDDEN));
      this.soundOnIcons.forEach((icon) => icon.classList.remove(HIDDEN));
      this.soundIconSmall?.setAttribute('aria-label', 'Mute video');
    }

    this.soundIconBig.classList.remove(HIDDEN);

    setTimeout(() => {
      this.soundIconBig.classList.add(HIDDEN);
    }, this.animationTimeout);
  };

  setVideoSize = () => {
    if (this.poster.clientHeight !== 0) {
      if (isMobile()) {
        this.container.style.width = '100%';
        this.video.style.width = '100%';
      } else {
        this.container.style.height = `${this.poster.clientHeight}px`;
        this.video.style.height = `${this.poster.clientHeight}px`;
      }
    }

    this.video.play();
    this.video.classList.remove(HIDDEN);
    this.poster.classList.add(HIDDEN);
    this.soundIconSmall?.classList.remove(HIDDEN);
  };

  handlePlay = () => {
    const posterImage = this.poster.querySelector('img');

    if (posterImage && !posterImage.complete) {
      posterImage.addEventListener('load', this.setVideoSize, { once: true });
    } else {
      this.setVideoSize();
    }
  };

  initialize = () => {
    this.video.load();
    this.video.addEventListener('canplay', this.handlePlay);

    if (this.video.dataset.audioDisabled !== 'true') {
      this.video.addEventListener('click', () => this.toggleSound());
      this.video.addEventListener('volumechange', () => this.toggleSoundIcons());
      this.soundIconSmall.addEventListener('click', () => this.toggleSound());
      this.soundIconSmall.addEventListener('keydown', onActivationKey(() => this.toggleSound()));
    }
  };
}
